import $axios from '@/service/httpServer'


export const getContractList = params=>$axios.get(`/pdp/xcx/contract/contractInfos`, params); //获取合同列表

export const getContractRepairInfos = params=>$axios.get(`/pdp/xcx/contract/repairInfos`, params); //获取补充协议合同列表


export const getContracStaistics =params=>$axios.get(`/pdp/xcx/contract/statistics`, params)  //获取合同概览

export const getContractListByid = params=>$axios.get(`/pdp/xcx/settlement/logInfo`, params); //根据合同id查询结算列表

export const getContracStaisticsByid =params=>$axios.get(`/pdp/xcx/contract/contractInfo`, params)  //根据合同id查询合同信息

export const getContractSettleList = params=>$axios.get(`pdp/xcx/settlement/settlementInfos`, params); //获取合同结算列表

export const getContractSettleStaistics = params=>$axios.get(`/pdp/xcx/settlement/statistics`, params); //获取合同结算概览
